import { splunk } from '@fs/zion-splunk-logger'
import { getAllBadActorData } from './badActorStore'
import checkForBigEditDistance from './checkForBigEditDistance'
import checkForProfanity from './checkForProfanity'
import checkForSanitizedCharacters from './checkForSanitizedCharacters'
import checkForTooManySpaces from './checkForTooManySpaces'

const promiseChain = [checkForBigEditDistance, checkForSanitizedCharacters, checkForTooManySpaces, checkForProfanity]

/**
 * Intercepts the save operation and checks the edited value against various rules before allowing the save to proceed.
 *
 * @param {array} editedValue - The value that was edited and is being saved and the original value.
 * @returns {Promise<boolean>} - Returns true if the save should be intercepted and prevented, false otherwise.
 */
export default async function saveInterceptor(editedValue) {
  if (!Array.isArray(editedValue)) {
    throw new Error('editedValue must be an array')
  }
  try {
    // comes from recordEnhancementService.saveEdit
    if (editedValue.length === 1) {
      const payload = editedValue[0]
      const editedTerm = payload?.editedValue
      const originalTerm = payload?.origValue?.text
      const data = await Promise.all(promiseChain.map((fn) => fn(editedTerm, originalTerm)))
      const interceptSave = data.some((result) => result)
      if (interceptSave) {
        const badActorData = await getAllBadActorData()
        splunk.log({ editedTerm, originalTerm, badActorData, type: 'quick_name_review' })
      }
      return interceptSave
    }
    // comes from recordEnhancementService.saveTaskEdits
    const slsPayload = editedValue
    const terms = slsPayload
      .filter((term) => term.elementType === 'FIELD')
      .map((term) => ({
        editedText: term?.fieldValueArg?.origValue?.text,
        originalText: term?.originalValue,
      }))
    const data = await Promise.all(
      terms.map((term) => Promise.all(promiseChain.map((fn) => fn(term?.editedText, term?.originalText))))
    )
    const interceptSave = data.some((result) => result.some((r) => r))
    if (interceptSave) {
      const badActorData = await getAllBadActorData()
      splunk.log({ terms, badActorData, type: 'full_name_review' })
    }
    return interceptSave
  } catch (error) {
    console.error('Error in saveInterceptor', error)
    return false
  }
}
